<template>
  <div></div>
</template>
<script>
import { GetPhoneMessage } from '@/query/api'
import { todoRel } from '@/assets/js/common'
import { sm2Encrypt } from '@/utils/sm2Util'
import { mapMutations } from 'vuex'
import { getGTHeaders, isGeetestRequiredCode, onShowCaptchaForRetry } from '../utils/geetest'

export default {
  name: 'phoneCode',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    phone: String,
    codeType: Number
  },
  data () {
    return {
      calculationTime: 60,
      timeInterval: ''
    }
  },
  watch: {
    show: function (val) {
      if (val === true) {
        this.getCode()
      }
    }
  },
  methods: {
    ...mapMutations(['timeChange']),
    tips (msg) {
      this.$message({
        message: msg,
        duration: 1000
      })
    },
    countDown () {
      if (this.timeInterval) {
        clearInterval(this.timeInterval)
      }
      this.timeInterval = setInterval(() => {
        if (this.calculationTime > 0) {
          this.calculationTime--
          this.timeChange(this.calculationTime)
        } else {
          this.calculationTime = 60
          clearInterval(this.timeInterval)
          this.timeChange('重新获取')
          this.$emit('showChange', false)
        }
      }, 1000)
    },
    getCode () {
      // 获取短信验证码
      const param = {
        phoneNum: sm2Encrypt(this.phone) || null,
        type: this.codeType
      }
      this.sendPhoneMessage(param)
    },
    sendPhoneMessage (param) {
      const headers = getGTHeaders('getCode')
      GetPhoneMessage({params: param, config: headers}).then(rel => {
        todoRel(rel, () => {
          this.tips('验证码发送成功,请注意查收')
          localStorage.setItem('startTime', new Date().getTime())
          this.countDown()
          this.finishSending()
        }, () => {
          if (isGeetestRequiredCode(rel)) {
            onShowCaptchaForRetry(() => {
              this.sendPhoneMessage(param)
            }, 'getCode')
          } else {
            this.tips(rel.retmsg)
            this.finishSending()
          }
        })
      })
    },
    finishSending () {
      this.$emit('showChange', false)
    },
    inspectTime () {
      let startTime = localStorage.getItem('startTime')
      let nowTime = new Date().getTime()
      let differ = parseInt((nowTime - startTime) / 1000) // 时间差
      if (differ > 60) {
        localStorage.setItem('startTime', new Date().getTime())
      } else if (differ < 60) {
        this.calculationTime = 60 - differ
        this.countDown()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/phoneCode.vue